import { SiteMenuOrder, Supply } from '.';
import Route from './route';
import Site from './site';
import {
  BaseEntity,
  JsonApiProperty,
  JsonApiRelationship,
  JsonApiResource,
} from '../jsonapi-provider';

@JsonApiResource({
  type: 'site-menu-supply-order',
})
export default class SiteMenuSupplyOrder extends BaseEntity {
  @JsonApiProperty({ resolver: Number, readOnly: true }) unitPrice: number = 0.0;
  @JsonApiProperty({ resolver: Number, readOnly: true }) totalPrice: number = 0.0;
  @JsonApiProperty({ type: 'string', readOnly: true }) supplyName: string = '';
  @JsonApiProperty({ resolver: Number }) quantity: number = 0;

  @JsonApiRelationship('site') site = new Site();
  @JsonApiRelationship('supply') supply = new Supply();
  // @JsonApiRelationship('cycle-menu-supply') cycleMenuSupply = new CycleMenuSupply();
  @JsonApiRelationship('route') route = new Route();
  @JsonApiRelationship('site-menu-order') siteMenuOrder = new SiteMenuOrder();
}

export interface SiteMenuSupplyOrderView
  extends Omit<SiteMenuSupplyOrder, 'site' | 'route' | 'siteMenuOrder' | 'supply'> {}

export const toSiteMenuSupplyOrderView = (smso: SiteMenuSupplyOrder): SiteMenuSupplyOrderView => {
  return {
    unitPrice: smso?.unitPrice,
    totalPrice: smso?.totalPrice,
    quantity: smso?.quantity,
    supplyName: smso?.supplyName,
  };
};
